var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "idle-cat",
      attrs: { type: "button", "aria-label": _vm.label },
      on: { click: _vm.onTap },
    },
    [
      _c("span", { ref: "catBody", staticClass: "idle-cat__body" }, [
        _vm.imageSrc
          ? _c("img", {
              staticClass: "idle-cat__image",
              attrs: { src: _vm.imageSrc, alt: "", draggable: "false" },
              on: {
                error: function ($event) {
                  _vm.showFallback = true
                },
              },
            })
          : _c(
              "span",
              {
                staticClass: "idle-cat__fallback",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("🐱")]
            ),
      ]),
      _vm._l(_vm.notes, function (note) {
        return _c(
          "span",
          {
            key: note.id,
            ref: `note-${note.id}`,
            refInFor: true,
            staticClass: "idle-cat__note",
          },
          [_vm._v(" " + _vm._s(note.glyph) + " ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }